import { useState } from 'react';
export default function useStack(pStack) {
  const [stack, setStack] = useState(pStack || []);
  function push(itemOrItems) {
    if (Array.isArray(itemOrItems)) {
      setStack(s => [...s, ...itemOrItems]);
    } else {
      setStack(s => [...s, itemOrItems]);
    }
  }
  function pop() {
    setStack(s => s.slice(0, s.length - 1));
  }
  function top() {
    return stack[stack.length - 1];
  }
  function isEmpty() {
    return stack.length === 0;
  }
  return {
    stack,
    push,
    pop,
    top,
    isEmpty
  };
}